module.exports = __webpack_public_path__ + "img/sec2-mobile.4432be2.svg";